import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _03f68d8d = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _3153f545 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _580f5f68 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _4b624494 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _0ca7cb54 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _475fee60 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _4c25c1c4 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _5565c879 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _5ec74e42 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _18f8203a = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _48db6677 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _526c620e = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _fcaabc02 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _05055c56 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _5a522364 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _3f64da8e = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _5a230f60 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _d48030d4 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _aad663f6 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _a84fc536 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _4fcb2380 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _0a8c8ec8 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _4b961450 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _39e2e81d = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _f6b1c4ba = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _87f1093c = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _3dd3d624 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _4cf18f9e = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _4a31857c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _1155fcec = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _ab2219ba = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _4680938a = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _536d6502 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _e5d8fa92 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _08603ab9 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _3891a0ea = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _98435c34 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _1c233d50 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _9423a134 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _a0d1c86c = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _cf026c6c = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _46685854 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _5eea1229 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _42cd5f24 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _70b84c27 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _534c4973 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _31c9a71d = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _0b2415b7 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _34e0fb7f = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _2cdad656 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _539bba1c = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _c5c49438 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _6cf14b0a = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _fc2e5626 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2d5ebbc0 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _510f0905 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _729e6c3e = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _dba2ae3e = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _cee6ddb8 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _cd7e9462 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _692300b3 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _403ae186 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _5a7aa3a7 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _2b7e7242 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _168395ce = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _8216e196 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _0183c860 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _61cfbd32 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _2dee8b84 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _e6100dac = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _2ba2cac2 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _6b894b6f = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _7fde88fa = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _0237f031 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _7311dde7 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _32413ba1 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _03f68d8d,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _3153f545,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _580f5f68,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _4b624494,
    name: "calendar"
  }, {
    path: "/customer",
    component: _0ca7cb54,
    name: "customer"
  }, {
    path: "/details",
    component: _475fee60,
    name: "details"
  }, {
    path: "/goals",
    component: _4c25c1c4,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _5565c879,
    name: "maisoku"
  }, {
    path: "/media",
    component: _5ec74e42,
    name: "media"
  }, {
    path: "/privacy",
    component: _18f8203a,
    name: "privacy"
  }, {
    path: "/project",
    component: _48db6677,
    name: "project"
  }, {
    path: "/response",
    component: _526c620e,
    name: "response"
  }, {
    path: "/sale",
    component: _fcaabc02,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _05055c56,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _5a522364,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _3f64da8e,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _5a230f60,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _d48030d4,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _aad663f6,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _a84fc536,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _4fcb2380,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _0a8c8ec8,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _4b961450,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _39e2e81d,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _f6b1c4ba,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _87f1093c,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _3dd3d624,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _4cf18f9e,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _4a31857c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _1155fcec,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _ab2219ba,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _4680938a,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _536d6502,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _e5d8fa92,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _08603ab9,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _3891a0ea,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _98435c34,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _1c233d50,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _9423a134,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _a0d1c86c,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _cf026c6c,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _46685854,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _5eea1229,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _42cd5f24,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _70b84c27,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _534c4973,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _31c9a71d,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _0b2415b7,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _34e0fb7f,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _2cdad656,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _539bba1c,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _c5c49438,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _6cf14b0a,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _fc2e5626,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _2d5ebbc0,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _510f0905,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _729e6c3e,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _dba2ae3e,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _cee6ddb8,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _cd7e9462,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _692300b3,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _403ae186,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _5a7aa3a7,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _2b7e7242,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _168395ce,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _8216e196,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _0183c860,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _61cfbd32,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _2dee8b84,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _e6100dac,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _2ba2cac2,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _6b894b6f,
    name: "property-property",
    children: [{
      path: "contact",
      component: _7fde88fa,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _0237f031,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _7311dde7,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _32413ba1,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
